import { HeartHandshake } from "lucide-react";

export const isPalestine = (p) => p?.category === "palestine" || p?.slug === "palestine" || /palestine/i.test(p?.name || "");
export const SPECIAL_EDITION = "Special Edition";
export const showsSpecialEdition = (p) => isPalestine(p) && !/special edition/i.test(p?.badge || "");

export const SpecialEditionPill = ({ slug, small = false }) => (
  <span data-testid={`special-edition-${slug}`} className={`font-mono-d uppercase tracking-[0.2em] text-white bg-[#007a3d] rounded-full whitespace-nowrap ${small ? "text-[9px] px-2.5 py-1" : "text-[10px] px-3 py-1.5"}`}>
    {SPECIAL_EDITION}
  </span>
);

export const PalestineCauseBanner = ({ variant = "light", compact = false, testId = "palestine-cause-banner" }) => {
  const dark = variant === "dark";
  return (
    <div
      data-testid={testId}
      className={`flex items-center gap-3 rounded-2xl border px-4 ${compact ? "py-2.5" : "py-3.5"} ${
        dark ? "bg-[#f5f4ee]/[0.06] border-[#f5f4ee]/15 text-[#f5f4ee]" : "bg-[#0a0a0b] border-[#0a0a0b] text-white"
      }`}
    >
      <span className="h-9 w-9 shrink-0 rounded-full bg-[#ff2a85] text-white flex items-center justify-center">
        <HeartHandshake size={16} />
      </span>
      <div className="min-w-0">
        <p className={`font-mono-d ${compact ? "text-[9px]" : "text-[10px]"} uppercase tracking-[0.25em] text-[#ff2a85]`}>Sales that give back</p>
        <p className={`${compact ? "text-xs" : "text-sm"} leading-snug mt-0.5`}>
          A portion of the profit from every Palestine Edition sale goes to the <span className="font-semibold">Palestine cause</span>.
        </p>
      </div>
    </div>
  );
};
